import React from "react";
import { MultilineText } from "./RichText";
import { useInicio } from "../../lib/inicio";

export default function SiteFooter() {
  const site = useInicio();

  return (
    <footer className="site-footer">
      <MultilineText text={site.rodapeTexto} />
      <br />
      &copy; {new Date().getFullYear()} {site.rodapeCopyright}
    </footer>
  );
}
